import { useState } from "react";
import "../../styles/globals.scss";
import "./styles.scss";

function CookiePolicyBanner() {
  const [showBanner, setShowBanner] = useState(true);
  const [cookiesAccepted, setCookiesAccepted] = useState(false);

  const handleAccept = () => {
    setCookiesAccepted(true);
    setShowBanner(false);
    localStorage.setItem("cookiesAccepted", true);
  };

  const handleReject = () => {
    setCookiesAccepted(false);
    setShowBanner(false);
    localStorage.setItem("cookiesAccepted", false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-policy-banner">
      <p>
        This site uses cookies to provide you with a better user experience.
      </p>
      <div className="cookie-policy-buttons">
        <button onClick={handleAccept}>Accept</button>
        <button onClick={handleReject}>Reject</button>
      </div>
    </div>
  );
}
 

export default CookiePolicyBanner;
